export const getItems = state => state.discardAllocation.items;

export default {
	getItems,
};
